<template>
  <el-aside width="auto" style="background: #fff">
    <el-menu
      class="menu__wrap el-menu-vertical-demo"
      router
      :default-active="$route.path"
      :collapse="isCollapse"
      :unique-opened="false"
      background-color="#F2F5FC"
    >
      <el-menu-item index="/home/index" v-if="department_module === 1 || department_module === 2">
        <div class="icon-home"></div>
        <span slot="title">工作台</span>
      </el-menu-item>
      <el-submenu v-for="item in routes" :key="item.name" :index="item.path">
        <template>
          <template slot="title">
            <div :class="'icon-' + item.path.substr(1)"></div>
            <span>{{ item.meta.title }}</span>
            <el-badge
              v-if="
                (item.path == '/approve' && (checking_total || my_checking_total)) ||
                (item.path == '/logmanage' && log_unread == 1) ||
                (item.path == '/admin' && time_out_aptitude_total > 0)
              "
              is-dot
              class="item"
              style="position: absolute; top: -10px"
            ></el-badge>
          </template>
          <el-menu-item-group>
            <template v-for="child in item.children">
              <el-menu-item :key="child.name" :index="child.path">
                <span style="margin-left: 10px">{{ child.meta.title }}</span>
                <el-badge
                  v-if="(child.path == '/logmanage/myget' && log_unread == 1)"
                  is-dot
                  class="item"
                  style="position: absolute; top: -10px"
                ></el-badge>
                <el-badge
                  v-if="(child.path == '/approve/my' && checking_total)"
                  :value="checking_total"
                  class="item"
                  style="position: absolute; top: -10px"
                ></el-badge>
                <el-badge
                  v-if="(child.path == '/approve/sponsor' && my_checking_total)"
                  :value="my_checking_total"
                  class="item"
                  style="position: absolute; top: -10px"
                ></el-badge>
                <el-badge
                  v-if="
                    (child.path == '/admin/aptitude' && time_out_aptitude_total > 0)
                  "
                  class="item"
                  :value="time_out_aptitude_total"
                  style="position: absolute; top: -10px"
                ></el-badge>
              </el-menu-item>
            </template>
          </el-menu-item-group>
        </template>
      </el-submenu>
    </el-menu>
  </el-aside>
</template>
<script>
import { getStorage } from "@/storage";
export default {
  name: "LayoutNaviBar",
  props: ["isCollapse"],
  data() {
    return {
      routes: [],
      isUnread: 0, //待我审核未读：1-有未读
      log_unread: 0,
      time_out_aptitude_total:0,
      department_module:getStorage('department_module'),
      my_checking_total:0,
      checking_total:0,
    };
  },
  watch: {
    "$store.state.isunread"() {
      this.getMyUnread();
      this.getnewNotify();
    },
    $route(to, form) {
      // 路由变化时，重新获取未读数统计信息
      if (to.name !== form.name) {
        this.getMyUnread();
        this.getnewNotify();
        this.getAiTeTotal()
      }
    },
  },
  mounted() {
    // this.routes = this.$router.options.routes[2].children;
    this.routes = this.$router.options.routes.slice(
      3,
      this.$router.options.routes.length - 1
    );
    this.getMyUnread();
    this.getnewNotify();
    this.getAiTeTotal();
  },
  methods: {
    // 未读数统计
    getMyUnread() {
      this.$http.post("/admin/employeeApproval/myUnread", {}).then((res) => {
        if (res.code === 1) {
          this.isUnread = res.data.unread;
          // my_checking_total-我发起的代处理、checking_total-待我处理
          this.my_checking_total = res.data.my_checking_total;
          this.checking_total = res.data.checking_total;
        }
      });
    },
    getnewNotify() {
      this.$http.post("/admin/workSpace/newNotify", {}).then((res) => {
        if (res.code === 1) {
          this.log_unread = res.data.log_unread;
          this.time_out_aptitude_total = res.data.time_out_aptitude_total;
        }
      });
    },
    getAiTeTotal() {
      this.$http.get("/admin/employeeApproval/atTotal", {params:{}}).then(res =>{
        if(res.code == 1) {
          this.$store.commit("setHeaderAiteTotal", res.data.unread);
        }
      })
    },
  },
};
</script>
<style scoped lang="scss">
.menu__wrap {
  height: 100%;
  box-sizing: border-box;
  &::v-deep {
    .el-menu-item-group__title {
      display: none;
    }
  }
  .menu-icon {
    margin-right: 10px;
  }
}
.el-menu {
  border: none;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
}
.el-menu-item:hover,
.el-menu-item:focus {
  background-color: #e6f1fd !important;
}
.menu__wrap ::v-deep .el-menu-item {
  min-width: 199px !important;
}
.handle {
  display: none;
}
</style>
<style >
.el-menu-item.is-active {
  background: #dde8f6 !important;
}
.el-submenu.is-active > .el-submenu__title {
  color: #409eff !important;
  font-weight: bold;
}
.el-submenu.is-active > .el-submenu__icon-arrow {
  color: #409eff !important;
}
.icon-home {
  width: 20px;
  height: 20px;
  background-image: url("~@/assets/img/nav/home.png");
  display: inline-block;
  margin: 0 10px 0 0;
}
.is-active .icon-home {
  background-image: url("~@/assets/img/nav/home-active.png");
}
.icon-personnel {
  width: 20px;
  height: 20px;
  background-image: url("~@/assets/img/nav/personnel.png");
  display: inline-block;
  margin: 0 10px 0 0;
}
.is-active .icon-personnel {
  background-image: url("~@/assets/img/nav/personnel-active.png");
}
.icon-admin {
  width: 20px;
  height: 20px;
  background-image: url("~@/assets/img/nav/admin.png");
  display: inline-block;
  margin: 0 10px 0 0;
}
.is-active .icon-admin {
  background-image: url("~@/assets/img/nav/admin-active.png");
}
.icon-financial {
  width: 20px;
  height: 20px;
  background-image: url("~@/assets/img/nav/financial.png");
  display: inline-block;
  margin: 0 10px 0 0;
}
.is-active .icon-financial {
  background-image: url("~@/assets/img/nav/financial-active.png");
}
.icon-approve {
  width: 20px;
  height: 20px;
  background-image: url("~@/assets/img/nav/approve.png");
  display: inline-block;
  margin: 0 10px 0 0;
}
.is-active .icon-approve {
  background-image: url("~@/assets/img/nav/approve-active.png");
}
.icon-set {
  width: 20px;
  height: 20px;
  background-image: url("~@/assets/img/nav/set.png");
  display: inline-block;
  margin: 0 10px 0 0;
}
.is-active .icon-set {
  background-image: url("~@/assets/img/nav/set-active.png");
}
.icon-logmanage {
  width: 20px;
  height: 20px;
  background-image: url("~@/assets/img/nav/i.png");
  display: inline-block;
  margin: 0 10px 0 0;
}
.is-active .icon-logmanage {
  background-image: url("~@/assets/img/nav/ia.png");
}

.icon-attendance {
  width: 20px;
  height: 20px;
  background-image: url("~@/assets/img/nav/att.png");
  display: inline-block;
  margin: 0 10px 0 0;
}
.is-active .icon-attendance {
  background-image: url("~@/assets/img/nav/att-active.png");
}

.display {
  display: none !important;
}
</style>
